import { z } from 'zod'

export const accountTotalsQuerySchema = z.object({
  startDate: z.string().optional(),
  endDate: z.string().optional(),
})

export type AccountTotalsQueryDto = z.infer<typeof accountTotalsQuerySchema>
